/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */

export type UserVoucherResDisplayStatus =
  (typeof UserVoucherResDisplayStatus)[keyof typeof UserVoucherResDisplayStatus];

export const UserVoucherResDisplayStatus = {
  IN_USE: 'IN_USE',
  UNUSED: 'UNUSED',
  USED: 'USED',
  EXPIRED: 'EXPIRED',
  DEACTIVATED: 'DEACTIVATED',
} as const;
